import React from 'react';
export function MenuLeftIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.005 16a1 1 0 01-.7-.29L9.29 12.717a1 1 0 010-1.414L12.277 8.3A1 1 0 1113.7 9.705l-2.286 2.3 2.3 2.286a1 1 0 01-.7 1.71h-.009z"
  }));
}